import CMSMasonryProductTileRegularTemplate from './CMSMasonryProductTileRegularTemplate/CMSMasonryProductTileRegularTemplate';

const templates = {
  REGULAR_MASONRY: CMSMasonryProductTileRegularTemplate,
};
export default templates;
